import { Pipe, PipeTransform, inject } from '@angular/core';
import { I18nService } from 'src/app/core/services/i18n.service';

@Pipe({
   name: 'i18n',
   standalone: true,
   pure: false,
})
export class I18nPipe implements PipeTransform {
   private i18nService = inject(I18nService);

   transform(phrase: string | null | undefined, params?: string[]): string {
      this.i18nService.translationsVersion();
      return this.i18nService.getTranslation(phrase || '', params);
   }
}
